/**
 * GENERATED by packages/templates/scripts/extract-theme.ts — do NOT hand-edit.
 * Run `pnpm --filter @repo/templates run extract-theme` to regenerate.
 *
 * @module
 */
import type { TemplateId, ThemeSummary } from "./templates.base.js"

export const THEME_SUMMARIES: Record<TemplateId, ThemeSummary> = {
  tpl_one: {"colors":{"brand":"#0EA5C9","brandFg":"#ffffff","bg":"#f8fafc","surface":"#ffffff","text":"#0f172a","textSoft":"#64748b","border":"#e2e8f0"},"fonts":{"heading":"Montserrat","body":"Open Sans"},"radiusMd":"0.75rem"},
  tpl_two: {"colors":{"brand":"#c79b56","brandFg":"#0a1628","bg":"#f8f4ec","surface":"#ffffff","text":"#0a1628","textSoft":"#6b6356","border":"#e8dfcc"},"fonts":{"heading":"Fraunces","body":"Inter"},"radiusMd":"0.3125rem"},
  tpl_three: {"colors":{"brand":"#ee7b22","brandFg":"#ffffff","bg":"#faf7f2","surface":"#ffffff","text":"#1b1815","textSoft":"#6b6358","border":"#e9e2d8"},"fonts":{"heading":"Poppins","body":"Inter"},"radiusMd":"0.875rem"},
}
